<template>
	<el-container class="index">

		<!-- Header start -->
		<el-header class="header" style="line-height: 3.75rem;height: 3.75rem !important;">
			<!-- 站点Logo -->
			<div class="el-logo">
				<el-link href="/index" target="_self" :underline="false">
					<el-image :src="src" alt=""></el-image>
				</el-link>
			</div>
			<!-- 导航菜单 -->
			<el-menu :default-active="1" class="el-menu el-dis" mode="horizontal" @select="handleSelect"
					 id="header-menu">
				<el-menu-item index="1">
					<el-link href="/index?vpath=/&vmode=1" target="_self">{{$t('message.headerMenu')}}</el-link>
				</el-menu-item>
			</el-menu>
			<!-- 用户栏 -->
			<div class="el-user" @mouseover="showLogin" @mouseleave="hideLogin">
				<el-avatar class="el-avatar el-xd-login"
						   icon="el-icon-user-solid"
						   default="Hell"
						   :src="user.userheader"
				/>
				<el-name class="el-name">{{ user.username }}
					<el-image :src="arrow_down" style="height: 1rem;margin-left: .3125rem;"></el-image>
				</el-name>
				<div class="el-login" style="display: none;">
					<el-header class="el-login-user">
						<el-row :gutter="5" style="padding-top: .9375rem;">
							<el-col :span="5" :push="1">
								<el-avatar class="el-avatar  x-larger el-xd-login"
										   icon="el-icon-user-solid"
										   default="Hell"
										   :src="user.userheader"
								/>
							</el-col>
							<el-col :span="19" :pull="6" style="color:#ffffff;text-align: right;">{{ user.username }}
							</el-col>
						</el-row>
					</el-header>
					<el-row class="el-user-logout">
						<el-col :span="24" :push="0">
							<el-link
							href="#"
							:underline="false"
							@click.native="logout"
							>{{$t('message.headerLoginOut')}}
							</el-link>
						</el-col>
					</el-row>
				</div>
			</div>
			<div class="el-lang">
				<el-image :src="langFlag" style="width: 1.875rem;top: 0px;visibility: hidden;"></el-image>
				<el-select v-model="value" @change="langChange" :placeholder="$t('message.headerlangSelect')"
						   style="position: relative;top: -2.8125rem;width: 6.875rem;">
					<el-option
					v-for="(item , key) in options"
					:selected="$env==item.value||$i18n.locale==item.value?true:false"
					:key="item.value"
					:value="item.value"
					:label="item.label">
						<!--<el-image
						  :src="item.flag"
						  alt="alt"
						  style="width: 30px;top: 5px;"
						>
						</el-image>
						<div class="el-flag-style"
						>{{ item.label }}</div>-->
					</el-option>
				</el-select>
			</div>
			<div class="el-skin"></div>
		</el-header>
		<!-- Header end -->


		<el-container class="body">
			<!-- Side start -->
			<el-aside style="min-width: 15.625rem;">
				<el-row class="tac">
					<el-col>
						<el-menu
						:default-active="1"
						mode="vertical"
						text-color=""
						active-text-color="#09AAFF"
						:default-openeds="[1]"
						>
							<el-link
							style="display: inline;"
							href="/index?vpath=/&vmode=1"
							target="_self"
							@click.native="renderMain('1')"
							>
								<el-submenu index="1">
									<template slot="title">
										<i class="el-icon-folder"></i>

										<span class="indexMenu">{{$t('message.sideMenuFileName')}}</span>

									</template>
								</el-submenu>
							</el-link>
							<!--<el-submenu index="2">
							  <template slot="title">
								<i class="el-icon-share"></i>
								<el-link
								  href="/#/index?vpath=/&vmode=2"
								  target="_self"
								  @click.native="renderMain('2')"
								>
								  <span>{{$t('message.sideMenuShareName')}}</span>
								</el-link>
							  </template>
							</el-submenu>-->
							<el-link
							style="display: inline;"
							href="/colle?vpath=/&vmode=3"
							target="_self"
							@click.native="renderMain(3)"
							>
								<el-submenu index="3">
									<template slot="title">
										<i class="el-icon-delete-solid"></i>

										<span class="colleMenu">{{$t('message.sideMenuCollectName')}}</span>

									</template>
								</el-submenu>
							</el-link>
						</el-menu>
					</el-col>
				</el-row>
				<div class="el-disk-free">
					<el-row class="xd-lrow xd-pos">
						<el-col :span="8" class="txt-left">{{ $t('message.sideUsedSpace') }}：</el-col>
						<el-col :span="16" style="padding-top: .875rem;">
							<el-progress
							:percentage="usedFree"
							:show-text="false"
							:status="diskFree.usedType"
							>
							</el-progress>
						</el-col>
					</el-row>
					<el-row class="xd-lrow">
						<el-col :span="16" :push="8" class="x-per el-disk-col-digit">
							{{diskFree.used}}{{diskFree.unitUsed}}/{{diskFree.total}}{{diskFree.unitTotal}}
						</el-col>
						<!--<el-col :span="6" class="el-disk-col-button" style="display: none">
							<el-button type="primary" size="small" @click="dilatation">{{ $t('message.dilatation') }}
							</el-button>
						</el-col>-->
					</el-row>
					<!--下载空间-->
					<el-row class="xd-lrow xd-pos" style="margin-top: .625rem">
						<el-col :span="8" class="txt-left">{{ $t('message.sideDownloadSpace') }}：</el-col>
						<el-col :span="16" style="padding-top: .875rem;">
							<el-progress
							:percentage="downFree"
							:show-text="false"
							:status="diskDownload.usedType"
							>
							</el-progress>
						</el-col>
					</el-row>
					<el-row class="xd-lrow">
						<el-col :span="16" :push="8" class="x-per el-disk-col-digit" style="margin-top: 0;">
							{{diskDownload.used}}{{diskDownload.unitUsed}}/{{diskDownload.total}}{{diskDownload.unitTotal}}
						</el-col>
						<!--<el-col :span="6" class="el-disk-col-button" style="display: none">
							<el-button type="primary" size="small" @click="dilatation">{{ $t('message.dilatation') }}
							</el-button>
						</el-col>-->
					</el-row>
					<el-row class="xd-lrow xd-notice">
						<el-col :span="24">
							<p>{{ $t('message.sideMonthlyDownloadNotice') }}</p>
						</el-col>
					</el-row>
				</div>
			</el-aside>
			<!-- Side end -->


			<!-- Main start -->
			<el-main style="font-size: 1rem;">
				<el-header class="el-main-header">
					<!-- 左侧文字提示 -->
					<div class="el-left el-main-header-left">
						<el-row>
							<el-col><span class="el-colle-title">
                               {{ $t('message.mainHeaderTitle') }}
                            </span></el-col>
						</el-row>
					</div>
					<div class="el-right el-main-header-right">
						<el-button type="primary"
								   size="small"
								   icon="el-icon-delete"
								   :title="$t('message.mainHeaderButton')"
								   @click="clearColleAll"
						>
							{{ $t('message.mainHeaderButton') }}
						</el-button>
					</div>
				</el-header>
				<el-container>
					<el-row class="el-table-title" :gutter="0">
						<el-col :span="2" :push="0" :pull="0"><span>{{ $t('message.collectName') }}</span></el-col>
						<el-col :span="3" :push="0" :pull="4" class="el-revert" style="visibility: hidden;"><span>
                            <el-button type="primary"
									   size="small"
									   icon="el-icon-refresh-left"
									   :title="$t('message.mainRevertIts')"
									   @click="rowsRevert"
							>
                            {{ $t('message.mainRevertIts') }}
                        </el-button>
                        </span></el-col>
						<el-col :span="19" :push="0">
							<div style="margin-right: 1rem;text-align: right;">{{$t('message.mainLoaded')
								}}，{{
                                $t('message.mainTotal') }}
								{{pager.total }} {{ $t('message.mainUnit') }}
							</div>
						</el-col>
					</el-row>
				</el-container>
				<el-container>
					<el-table
					:stripe="false"
					class="el-files"
					:data="tableData"
					:show-header="true"
					:empty-text="loaded"
					header-row-class-name="el-main-table-header"
					ref="selectData"
					@selection-change="selectionChange"
					@cell-mouse-leave="editorHide"
					@cell-mouse-enter="editorShow">
						<el-table-column width="30" type="selection">
						</el-table-column>
						<el-table-column prop="name"
										 fixed
										 :label="$t('message.mainFile')"
										 width="500"
										 v-if="tableHead.render===true"
						>
							<template slot-scope="scope">
								<el-row :gutter="0" type="flex" justify="space-between">
									<el-col :span="2" :pull="0" style="margin-top: .375rem;">
										<div v-if="scope.row.type == 1">
											<el-image :src="icons.fold" style="width: 1.5rem;"></el-image>
										</div>
										<div v-else-if="scope.row.type == 2">
											<el-image :src="icons.bin" style="width: 1.5rem;"></el-image>
										</div>
										<div v-else>
											<el-image :src="icons.text" style="width: 1.5rem;"></el-image>
										</div>
									</el-col>
									<el-col :span="14" :pull="2" :push="0" style="margin-top: .375rem;">
										<div
										v-bind:style="addFolderStyle"
										v-html="scope.row.name">
										</div>
									</el-col>
									<el-col :span="2" :pull="0" :push="0">

									</el-col>
									<el-col :span="2" :pull="0" :push="0">

									</el-col>
									<el-col :span="8" :push="2" class="x-table-hidden" style="visibility:hidden;">
										<div style="margin-top: .375rem;">
											<el-image @click="rowRevert(scope.row)" :src="icons.revert"
													  style="margin-right: .25rem;"
													  :title="`${$t('message.mainRevertIts')}`"></el-image>
											<el-image @click="rowRemove(scope.row)" :src="icons.delete"
													  style="margin-right: .25rem;"
													  :title="`${$t('message.mainFileDel')}`"></el-image>
										</div>
									</el-col>
								</el-row>
							</template>
						</el-table-column>
						<el-table-column
						prop="size"
						:label="$t('message.mainSize')"
						width="180">
						</el-table-column>
						<el-table-column
						prop="ctime"
						:label="$t('message.mianDelData')">
						</el-table-column>
					</el-table>
					<!--分页-->

					<template>
						<div class="el-table-pagination">
							<el-pagination
							layout="prev, pager, next"
							:total="pager.total"
							:page-size="pager.pageSize"
							:background="true"
							:next-text="$t('message.mainPageNext')"
							:prev-text="$t('message.mainPagePrev')"
							:pager-count="pager.pageCount"
							:current-page="pager.currentPage"
							:hide-on-single-page="true"
							@current-change="currentChange"
							>
							</el-pagination>
						</div>
					</template>
				</el-container>
			</el-main>
			<!-- Main end -->
		</el-container>
	</el-container>
</template>
<script type="text/babel">
    const langSeletor = require('../config/index');
    import xlogo_cn from  '../assets/logos/xhorse_cn.png';
    import xlogo_en from  '../assets/logos/xhorse_en.png';
    import ElOption from "../../node_modules/element-ui/packages/select/src/option";
    import ElSelect from "../../node_modules/element-ui/packages/select/src/select";
    import arrow_down from  '../assets/icons/arrow_down.png';
    import revertpng from  '../assets/icons/btn_revert.png';
    import deletepng from  '../assets/icons/btn_delete.png';
    import morepng from  '../assets/icons/btn_more.png';
    import foldpng from  '../assets/icons/btn_file.png';
    import binpng from  '../assets/icons/btn_bin.png';
    import textpng from  '../assets/icons/btn_dat.png';
    import cn from '../assets/images/flags/China.png';
    import en from '../assets/images/flags/United States.png';
    import German from '../assets/images/flags/Germany.png';
    import Japan from '../assets/images/flags/Japan.png';
    import Sk from '../assets/images/flags/South Korea.png';
    import Fran from '../assets/images/flags/France.png';
    import Russia from '../assets/images/flags/Russia.png';
    import Spain from '../assets/images/flags/Spain.png';
    import Portugal from '../assets/images/flags/Portugal.png';
    import Italy from '../assets/images/flags/Italy.png';
    import VietNam from '../assets/images/flags/Vietnam.png';
    import Arab from '../assets/images/flags/Saudi Arabia.png';
    import {loginOut, valiLogin} from '../../api/login';
    import {diskCapacity, diskSpaceWatcher} from '../../api/upload';
    import {useGetter} from '../../api/local';
    import {clearColle, getAllItem, genRowRevert, chunkData} from '../../api/colle';
    import ElContainer from "../../node_modules/element-ui/packages/container/src/main";
    import ElHeader from "../../node_modules/element-ui/packages/header/src/main";
    import ElCol from "element-ui/packages/col/src/col";
    import ElImage from "../../node_modules/element-ui/packages/image/src/main";
    import ElProgress from "../../node_modules/element-ui/packages/progress/src/progress";
    import ElRow from "element-ui/packages/row/src/row";
    import ElButton from "../../node_modules/element-ui/packages/button/src/button";
    export default {
        components: {
            ElOption,
            ElSelect,
            ElButton,
            ElRow,
            ElProgress,
            ElImage,
            ElCol,
            ElHeader,
            ElContainer
        },
        name: 'App',
		/*  支持语言 */
        data: function () {
            return {
                loaded: this.$t('message.loading'),
                filterKey: "",
                defaultProps: {
                    label: 'label',
                    children: 'children'
                },
                folderLayers: [],
                currentNodeAttr: {},
                diskFree: {
                    used: 0,
                    total: 0,
                    usedType: '',
                    usedInt: 0,
                    totalInt: 0,
                    unitUsed: 'B',
                    unitTotal: 'B'
                },
                diskDownload: {
                    used: 0,
                    total: 0,
                    usedType: '',
                    unitUsed: 'B',
                    unitTotal: 'B',
                    usedInt: 0,
                    totalInt: 0
                },
                arrow_down: arrow_down,
                uploader: {
                    accept: [],
                    maxSize: 10 * 1024 * 1024,
                    seqFiles: [],
                    maxLength: 5
                },
                user: {
                    username: localStorage.getItem('username'),
                    userheader: localStorage.getItem('userheader')
                },
                pager: {
                    currentPage: 1,
                    pageSize: 10,
                    total: 0,
                    pageCount: 7
                },
                keyword: "",
                selectData: [],
                tableHead: {
                    render: true,
                    allBack: false,
                    curdirs: null,
                    curdir: "0",
                },
                addFolderStyle: {
                    "height": "100%",
                    "width": "100%"
                }, viewLoader: "",
                qrstyle: {
                    "width": "160px",
                    "position": "relative",
                    "top": "0px",
                    "left": "75px"
                },
                tableData: [],
                dirname: this.$t('message.mainBuildDir'),
                dirConfig: {
                    maxLevel: 5
                },
                options: this.suplangs,
                value: this.$env == 'cn' ? '中文简体' : 'English',
                src: '',
                nationcode: 86,
                langFlag: cn,
                icons: {
                    revert: revertpng,
                    delete: deletepng,
                    more: morepng,
                    fold: foldpng,
                    bin: binpng,
                    text: textpng
                },
                dialogVisible: false

            }
        },
        computed: {
            usedFree: function () {
                const _this = this;
                const percentage = parseInt((_this.diskFree.usedInt / _this.diskFree.totalInt) * 100);
                if (percentage > 80) {
                    _this.usedType = 'exception';
                } else {
                    _this.usedType = '';
                }
                return parseInt((_this.diskFree.usedInt / _this.diskFree.totalInt) * 100);
            },
            downFree: function () {
                const _this = this;
                const percentage = parseInt((_this.diskDownload.usedInt / _this.diskDownload.totalInt) * 100);
                if (percentage > 80) {
                    _this.downloadType = 'exception';
                } else {
                    _this.downloadType = '';
                }
                return parseInt((_this.diskDownload.usedInt / _this.diskDownload.totalInt) * 100);
            }
        },
        watch: {
            filterKey(val) {
                this.$refs.tree.filter(val);
            }
        },
        methods: {
            // 清空回收站
            clearColleAll(evt){
                const _this = this;
                const nationcode = _this.$store.state.nation.code;
                _this.$confirm(
                _this.$t('message.confirmClearAll'),
                _this.$t('message.messageBoxTitle'),
                {
                    confirmButtonText: _this.$t('message.sure'),
                    cancelButtonText: _this.$t('message.cancel'),
                    center: false,
                    closeOnPressEscape: true,
                    dangerouslyUseHTMLString: true,
                    customClass: "x-notice",
                    callback: function (action) {
                        if (String(action) == 'confirm') {
                            clearColle(['All'], nationcode).then((res) => {
                                if (res && res.data.error == 0) {
                                    _this.tableData = [];
                                    _this.pager.currentPage = 1;
                                    _this.pager.total = 0;
                                    _this.loaded = _this.$t("message.loaded");
                                }
                            }).catch((err) => {
                                _this.$message.error(_this.$t('message.messageServerIsBusy'));
                            });
                        } else {
                            //
                        }
                    }
                });
            },
            // 还原单行
            rowRevert(row){
                //console.log(row);
                const _this = this;
                const nationcode = _this.$store.state.nation.code;
                const selid = [];
                selid.push(row.id);
                _this.$confirm(
                _this.$t('message.messageBoxConfirmRevert'),
                _this.$t('message.messageBoxTitle'),
                {
                    confirmButtonText: _this.$t('message.sure'),
                    cancelButtonText: _this.$t('message.cancel'),
                    center: false,
                    dangerouslyUseHTMLString: true,
                    closeOnPressEscape: true,
                    customClass: "x-notice",
                    callback: function (action) {
                        if (String(action) == 'confirm') {
                            genRowRevert(selid, nationcode).then((res) => {
                                if (res && res.data.error == 0) {
                                    getAllItem(_this.pager, nationcode).then(
                                    function (res) {
                                        if (res && parseInt(res.data.error) === 0) {
                                            const seek = res.data.data;
                                            const list = seek.list;
                                            const count = seek.count;
                                            if (list.length <= 0 && _this.pager.currentPage > 1) {
                                                const currentPage = _this.pager.currentPage;
                                                _this.pager.currentPage = currentPage <= 1 ? 1 : (parseInt(currentPage) - 1);
                                                getAllItem(_this.pager, nationcode).then(
                                                function (res) {
                                                    if (res && parseInt(res.data.error) === 0) {
                                                        const seek = res.data.data;
                                                        const list = seek.list;
                                                        const count = seek.count;
                                                        _this.tableData = list;
                                                        _this.pager.total = parseInt(count);
                                                        _this.loaded = _this.$t("message.loaded");
                                                        // 动态渲染分页
                                                    } else {
                                                        _this.tableData = [];
                                                        _this.pager.total = 0;
                                                        _this.loaded = _this.$t("message.loaded");
                                                    }
                                                }
                                                );
                                            } else {
                                                _this.tableData = list;
                                                _this.pager.total = parseInt(count);
                                                _this.loaded = _this.$t("message.loaded");
                                            }
                                            // 动态渲染分页
                                        } else {
                                            _this.tableData = [];
                                            _this.pager.total = 0;
                                            _this.loaded = _this.$t("message.loaded");
                                        }
                                    }
                                    );
                                    // 获取用户磁盘容量
                                    diskSpaceWatcher(nationcode).then(function (res) {
                                        if (res && res.data.error == '0') {
                                            let usage = res.data.data.list;
                                            _this.diskFree.used = usage.used;
                                            _this.diskFree.total = usage.total;
                                            _this.diskFree.usedInt = usage.usedInt;
                                            _this.diskFree.totalInt = usage.totalInt;
                                            _this.diskFree.unitUsed = usage.unitUsed;
                                            _this.diskFree.unitTotal = usage.unitTotal;
                                            return false;
                                        } else {
                                            _this.$message.error(_this.$t('message.messageServerIsBusy'));
                                            return false;
                                        }
                                    });
                                } else {
                                    _this.selectData = [];
                                    _this.$refs.selectData.clearSelection();
                                    if (res && res.data.error == 1 && res.data.status == 2016) {
                                        _this.$message.error(_this.$t('message.messageDiskFreeFull'));
                                        return false;
                                    }
                                }
                            }).catch((err) => {
                                console.log(err);
                                _this.$message.error(_this.$t('message.messageServerIsBusy'));
                            });
                        } else {
                            //
                        }
                    }
                });
            },
            // 删除单行
            rowRemove(row){
                const _this = this;
                const selid = [];
                const nationcode = _this.$store.state.nation.code;
                _this.$confirm(
                _this.$t('message.confirmClear'),
                _this.$t('message.messageBoxTitle'),
                {
                    confirmButtonText: _this.$t('message.sure'),
                    cancelButtonText: _this.$t('message.cancel'),
                    center: false,
                    dangerouslyUseHTMLString: true,
                    closeOnPressEscape: true,
                    customClass: "x-notice",
                    callback: function (action) {
                        if (String(action) == 'confirm') {
                            selid.push(row.id);
                            clearColle(selid, nationcode).then((res) => {
                                console.log(res);
                                if (res && res.data.error == 0) {
                                    getAllItem(_this.pager, nationcode).then(
                                    function (res) {
                                        if (res && parseInt(res.data.error) === 0) {
                                            const seek = res.data.data;
                                            const list = seek.list;
                                            const count = seek.count;
                                            if (list.length <= 0 && _this.pager.currentPage > 1) {
                                                const currentPage = _this.pager.currentPage;
                                                _this.pager.currentPage = currentPage <= 1 ? 1 : (parseInt(currentPage) - 1);
                                                getAllItem(_this.pager, nationcode).then(
                                                function (res) {
                                                    if (res && parseInt(res.data.error) === 0) {
                                                        const seek = res.data.data;
                                                        const list = seek.list;
                                                        const count = seek.count;
                                                        _this.tableData = list;
                                                        _this.pager.total = parseInt(count);
                                                        _this.loaded = _this.$t("message.loaded");
                                                        // 动态渲染分页
                                                    } else {
                                                        _this.tableData = [];
                                                        _this.pager.total = 0;
                                                        _this.loaded = _this.$t("message.loaded");
                                                    }
                                                }
                                                );
                                            } else {
                                                _this.tableData = list;
                                                _this.pager.total = parseInt(count);
                                                _this.loaded = _this.$t("message.loaded");
                                            }
                                            // 动态渲染分页
                                        } else {
                                            _this.tableData = [];
                                            _this.pager.total = 0;
                                            _this.loaded = _this.$t("message.loaded");
                                        }
                                    }
                                    );
                                }
                            }).catch((err) => {
                                console.log(err);
                                _this.$message.error(_this.$t('message.messageServerIsBusy'));
                            });
                        } else {
                            //
                        }
                    }
                });


            },
            // 还原多行
            rowsRevert(){
                const _this = this;
                const selid = [];
                const nationcode = _this.$store.state.nation.code;
                jQuery.each(_this.selectData, function (i, e) {
                    selid.push(e.id)
                });
                _this.$confirm(
                _this.$t('message.messageBoxConfirmRevert'),
                _this.$t('message.messageBoxTitle'),
                {
                    confirmButtonText: _this.$t('message.sure'),
                    cancelButtonText: _this.$t('message.cancel'),
                    center: false,
                    dangerouslyUseHTMLString: true,
                    closeOnPressEscape: true,
                    customClass: "x-notice",
                    callback: function (action) {
                        if (String(action) == 'confirm') {
                            genRowRevert(selid, nationcode).then((res) => {
                                if (res && res.data.error == 0) {
                                    getAllItem(_this.pager, nationcode).then(
                                    function (res) {
                                        if (res && parseInt(res.data.error) === 0) {
                                            const seek = res.data.data;
                                            const list = seek.list;
                                            const count = seek.count;
                                            _this.tableData = list;
                                            if (list.length <= 0 && _this.pager.currentPage > 1) {
                                                const currentPage = _this.pager.currentPage;
                                                _this.pager.currentPage = currentPage <= 1 ? 1 : (parseInt(currentPage) - 1);
                                                getAllItem(_this.pager, nationcode).then(
                                                function (res) {
                                                    if (res && parseInt(res.data.error) === 0) {
                                                        const seek = res.data.data;
                                                        const list = seek.list;
                                                        const count = seek.count;
                                                        _this.tableData = list;
                                                        _this.pager.total = parseInt(count);
                                                        _this.loaded = _this.$t("message.loaded");
                                                        // 动态渲染分页
                                                    } else {
                                                        _this.tableData = [];
                                                        _this.pager.total = 0;
                                                        _this.loaded = _this.$t("message.loaded");
                                                    }
                                                }
                                                );
                                            } else {
                                                _this.tableData = list;
                                                _this.pager.total = parseInt(count);
                                                _this.loaded = _this.$t("message.loaded");
                                            }
                                            // 动态渲染分页
                                        } else {
                                            _this.tableData = [];
                                            _this.pager.total = 0;
                                            _this.loaded = _this.$t("message.loaded");
                                        }
                                    }
                                    );
                                    // 获取用户磁盘容量
                                    diskSpaceWatcher(nationcode).then(function (res) {
                                        if (res && res.data.error == '0') {
                                            let usage = res.data.data.list;
                                            _this.diskFree.used = usage.used;
                                            _this.diskFree.total = usage.total;
                                            _this.diskFree.usedInt = usage.usedInt;
                                            _this.diskFree.totalInt = usage.totalInt;
                                            _this.diskFree.unitUsed = usage.unitUsed;
                                            _this.diskFree.unitTotal = usage.unitTotal;
                                            return false;
                                        } else {
                                            _this.$message.error(_this.$t('message.messageServerIsBusy'));
                                            return false;
                                        }
                                    });
                                } else {
                                    _this.selectData = [];
                                    _this.$refs.selectData.clearSelection();
                                    if (res && res.data.error == 1 && res.data.status == '2016') {
                                        _this.$message.error(_this.$t('message.messageDiskFreeFull'));
                                        return false;
                                    }
                                }
                            }).catch((err) => {
                                _this.$message.error(_this.$t('message.messageServerIsBusy'));
                            });
                        } else {
                            //
                        }
                    }
                });
            },
            // table 复选框点击
            selectionChange(selection){
                const _this = this;
                _this.selectData = selection;
                if (_this.selectData.length > 0) {
                    jQuery(".el-col.el-revert").css({"visibility": "visible"});
                } else {
                    jQuery(".el-col.el-revert").css({"visibility": "hidden"})
                }
            },
            // 分页组件
            currentChange(currentPage){
                const _this = this;
                const cdir = _this.tableHead.curdir;
                const nationcode = isNaN(_this.$store.state.nation.code) ? 86 : _this.$store.state.nation.code;
                _this.pager.currentPage = currentPage;
                chunkData(cdir, _this.pager, nationcode).then(
                function (response) {
                    try {
                        if (response && parseInt(response.data.error) === 0) {
                            const seek = response.data.data;
                            // 渲染表格
                            _this.tableData = seek.list;

                        }
                    } catch (e) {
                        console.log(e)
                    }
                }
                );

            },
            // 左侧菜单栏
            renderMain(typeCode){

            },
            editorShow(row, column, cell, event){
                //鼠标移入显示编辑label
                jQuery(cell).find("div.x-table-hidden").css({"visibility": "visible"});
            },
            editorHide(row, column, cell, event){
                //鼠标移出隐藏编辑label
                jQuery(cell).find("div.x-table-hidden").css({"visibility": "hidden"});
            },

            langChange(item){
                //切换语言
                switch (item) {
                    case 'cn':
                        this.$store.state.language = 'cn';
                        this.$i18n.locale = 'cn';
                        this.src = xlogo_cn;
                        this.langFlag = cn;
                        break;
                    case 'en':
                        this.$store.state.language = 'en';
                        this.$i18n.locale = 'en';
                        this.src = xlogo_en;
                        this.langFlag = en;
                        break;
				/* case 'dy':
				 this.$store.state.language = 'dy';
				 this.$i18n.locale = 'dy';
				 this.langFlag = German;
				 break;
				 case 'ry':
				 this.$store.state.language = 'ry';
				 this.$i18n.locale = 'ry';
				 this.langFlag = Japan;
				 break;
				 case 'hy':
				 this.$store.state.language = 'hy';
				 this.$i18n.locale = 'hy';
				 this.langFlag = Sk;
				 break;
				 case 'fy':
				 this.$store.state.language = 'fy';
				 this.$i18n.locale = 'fy';
				 this.langFlag = Fran;
				 break;
				 case 'ey':
				 this.$store.state.language = 'ey';
				 this.$i18n.locale = 'ey';
				 this.langFlag = Russia;
				 break;
				 case 'xby':
				 this.$store.state.language = 'xby';
				 this.$i18n.locale = 'xby';
				 this.langFlag = Spain;
				 break;
				 case 'ptyy':
				 this.$store.state.language = 'ptyy';
				 this.$i18n.locale = 'ptyy';
				 this.langFlag = Portugal;
				 break;
				 case 'ydly':
				 this.$store.state.language = 'ydly';
				 this.$i18n.locale = 'ydly';
				 this.langFlag = Italy;
				 break;
				 case 'yny':
				 this.$store.state.language = 'yny';
				 this.$i18n.locale = 'yny';
				 this.langFlag = VietNam;
				 break;
				 case 'alby':
				 this.$store.state.language = 'alby';
				 this.$i18n.locale = 'alby';
				 this.langFlag = Arab;
				 break;
				 default:
				 this.$store.state.language = 'cn';
				 this.$i18n.locale = 'cn';
				 this.langFlag = cn;
				 break;*/
                }
            },
            showLogin(){
                //用户信息窗显示
                jQuery(".el-login").show();
            },
            hideLogin(){
                //用户信息窗隐藏
                jQuery(".el-login").hide();
            },
            logout(){
                const _this = this;
                const userInfo = useGetter();
                if (userInfo) {
                    const user = userInfo.username;
                    loginOut(user).then(
                    function (response) {
                        if (response && parseInt(response.data.error) === 0 && parseInt(response.data.status) === 2007) {
                            /!*注销成功*!/
                            //1) 记录用户状态
                            _this.$store.commit('xlogout', {});
                            //2) 跳转至登录页
                            _this.qrstyle = {};
                            _this.$router.replace({path: '/'});
                        } else {
                            _this.$alert(_this.$t('message.messageServerIsBusy'));
                        }
                    }
                    );
                }

            },
            inputForceUpdate(e){
                this.$forceUpdate();
            },
            filterNode(value, data) {
                console.log(value);
                if (!value) return true;
                return data.label.indexOf(value) !== -1;
            }
        },
        created() {
            const _this = this;
            //验证用户是否登录
            const userInfo = useGetter();
            if (userInfo) {
                const username = userInfo.username;
                const nationcode = userInfo.usercode;
                const userarea = userInfo.userarea;
                const pager = {
                    currentPage: 1,
                    pageSize: 10
                };
                valiLogin(username, nationcode).then(
                function (response) {
                    if (response && parseInt(response.data.error) === 0) {
                    } else {
                        //用户未登录
                        _this.$router.push({name: 'login'});
                        return false;
                    }
                }
                );
                getAllItem(pager, nationcode).then(
                function (res) {
                    //console.log(res);
                    try {
                        if (res && parseInt(res.data.error) === 0) {
                            const seek = res.data.data;
                            const list = seek.list;
                            const count = seek.count;
                            // 渲染表格
                            _this.tableData = list;
                            // 存储状态
                            _this.pager.total = parseInt(count);
                            _this.pager.currentPage = 1;
                            _this.pager.pageSize = 10;

                            // 动态渲染分页
                            if (count < 1) {
                                _this.loaded = _this.$t('message.loaded');
                            }
                        }
                    } catch (e) {
                        console.log(e);
                    }
                }
                );
                // 选择
                _this.src = userarea == 0 ? xlogo_cn : xlogo_en;

            }

        },
        mounted() {
            const _this = this;
            const userInfo = useGetter();
            if (userInfo) {
                // 获取用户磁盘容量
                const nationcode = userInfo.usercode;
                const userarea = userInfo.userarea;
                diskSpaceWatcher(nationcode).then(function (res) {
                    if (res && res.data.error == '0') {
                        let usage = res.data.data.list;
                        let download = res.data.data.download;
                        _this.diskFree.used = usage.used;
                        _this.diskFree.total = usage.total;
                        _this.diskFree.usedInt = usage.usedInt;
                        _this.diskFree.totalInt = usage.totalInt;
                        _this.diskFree.unitUsed = usage.unitUsed;
                        _this.diskFree.unitTotal = usage.unitTotal;

                        _this.diskDownload.used = download.used;
                        _this.diskDownload.total = download.total;
                        _this.diskDownload.usedInt = download.usedInt;
                        _this.diskDownload.totalInt = download.totalInt;
                        _this.diskDownload.unitUsed = download.unitUsed;
                        _this.diskDownload.unitTotal = download.unitTotal;

                        if (parseInt((_this.diskFree.usedInt / _this.diskFree.totalInt) * 100) > 80) {
                            _this.diskFree.usedType = 'exception'
                        } else {
                            _this.diskFree.usedType = ''
                        }

                        if (parseInt((_this.diskDownload.usedInt / _this.diskDownload.totalInt) * 100) > 80) {
                            _this.diskDownload.usedType = 'exception'
                        } else {
                            _this.diskDownload.usedType = ''
                        }

                        return false;
                    } else {
                        _this.$message.error(_this.$t('message.messageServerIsBusy'));
                        return false;
                    }
                });
				/*  _this.src = userarea == 0 ? xlogo_cn : xlogo_en;*/
                // 默认地区码选择
                _this.nationcode = nationcode;
                langSeletor.init(userarea, _this);
            }
        }
    };
</script>

<style lang="css">
	@import '../assets/css/index/index.css';
	@import '../assets/css/index/header.css';
	@import '../assets/css/index/side.css';
	@import '../assets/css/index/main-common.css';
	@import '../assets/css/colle/index.css';
</style>
<style lang="css" scoped>
	.el-header {
		line-height: 3.75rem;
	}

	.el-header .el-account-rem {
		text-align: left !important;
	}

	.x-dialog.el-dialog__wrapper .el-dialog__title {
		font-size: 1rem !important;
	}

	.el-main-header-right {
		width: 25rem;
		position: absolute;
		right: 1rem;
		height: 2rem;
		text-align: right;
	}

	.el-table-title {
		margin-top: .5rem;
		margin-bottom: .5rem;
	}

	span.colleMenu {
		color: #409EFF;
	}

	.el-xd-login img {
		width: 100% !important;
	}
</style>





// WEBPACK FOOTER //
// src/components/colle.vue